var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.3131,
    cy: 21.5,
    rx: 21.8131,
    ry: 21.5,
    fill: "#50A682"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9733 13.54V19.26C22.9733 19.8667 22.9433 20.4633 22.8833 21.05C22.8233 21.63 22.7467 22.2467 22.6533 22.9H20.9733C20.88 22.2467 20.8033 21.63 20.7433 21.05C20.6833 20.4633 20.6533 19.8667 20.6533 19.26V13.54H22.9733ZM20.2633 26.64C20.2633 26.4333 20.3 26.2367 20.3733 26.05C20.4533 25.8633 20.56 25.7033 20.6933 25.57C20.8333 25.4367 20.9967 25.33 21.1833 25.25C21.37 25.17 21.57 25.13 21.7833 25.13C21.99 25.13 22.1867 25.17 22.3733 25.25C22.56 25.33 22.72 25.4367 22.8533 25.57C22.9933 25.7033 23.1033 25.8633 23.1833 26.05C23.2633 26.2367 23.3033 26.4333 23.3033 26.64C23.3033 26.8533 23.2633 27.0533 23.1833 27.24C23.1033 27.42 22.9933 27.5767 22.8533 27.71C22.72 27.8433 22.56 27.9467 22.3733 28.02C22.1867 28.1 21.99 28.14 21.7833 28.14C21.57 28.14 21.37 28.1 21.1833 28.02C20.9967 27.9467 20.8333 27.8433 20.6933 27.71C20.56 27.5767 20.4533 27.42 20.3733 27.24C20.3 27.0533 20.2633 26.8533 20.2633 26.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c2410ec4ecf38f8e50fe4538af590066.svg";
export { ForwardRef as ReactComponent };